/**
 * DuckAssist journey — protocol `discovery-only` (ADR-0159 §3).
 * DuckAssistBot is DuckDuckGo's retrieval crawler (user-invoked, not
 * training).
 */

import { buildDiscoveryOnlyTerminalPhase } from './discovery-only-terminal.js';
import { buildDiscoveryPhase, buildReadMenuPhase } from './discovery.js';
import type { JourneyContext, Phase } from './types.js';

export function buildDuckDuckGoJourney(ctx: JourneyContext): Phase[] {
  const { agent, live, installed, cardUrl, catalogUrl, liveProducts } = ctx;
  return [
    buildDiscoveryPhase(agent, installed, cardUrl, live.card),
    buildReadMenuPhase(agent, installed, catalogUrl, live.catalog, liveProducts),
    buildDiscoveryOnlyTerminalPhase(agent),
  ];
}
